import { FaWhatsapp, FaInstagram, FaTelegram } from "react-icons/fa";

export const providers = {
    whatsapp: {
        label: "WhatsApp",
        icon: FaWhatsapp,
        color: "#25D366",
        providers: {
            zapi: {
                label: "Z-API",
                icon: FaWhatsapp,
                fields: [
                    {
                        name: "instance_id",
                        label: "ID da Instância",
                        required: true,
                        placeholder: "Ex.: 1234567890"
                    },
                    {
                        name: "token",
                        label: "Token",
                        required: true,
                        placeholder: "Ex.: abcd1234efgh5678"
                    },
                    {
                        name: "client_token",       // ✅ corrigido (era security_token)
                        label: "Client Token",
                        required: true,
                        placeholder: "Ex.: Fc1234567890abcd"
                    }
                ]
            },
            cloud_api: {
                label: "WhatsApp Cloud API",
                fields: [
                    {
                        name: "phone_number_id",
                        label: "Phone Number ID",
                        required: true,
                        placeholder: "Ex.: 1234567890"
                    },
                    {
                        name: "access_token",
                        label: "Access Token",
                        required: true,
                        placeholder: "Ex.: EAABsbCS..."
                    }
                ]
            }
        }
    },

    telegram: {
        label: "Telegram",
        icon: FaTelegram,
        color: "#229ED9",
        providers: {
            bot_api: {
                label: "Telegram Bot API",
                fields: [
                    {
                        name: "bot_token",
                        label: "Bot Token",
                        required: true,
                        placeholder: "Ex.: 123456:ABC-DEF..."
                    }
                ]
            }
        }
    },

    instagram: {
        label: "Instagram",
        icon: FaInstagram,
        color: "#E1306C",
        providers: {
            meta: {
                label: "Meta Graph API",
                fields: [
                    {
                        name: "page_id",
                        label: "Page ID",
                        required: true,
                        placeholder: "Ex.: 1234567890"
                    },
                    {
                        name: "access_token",
                        label: "Access Token",
                        required: true,
                        placeholder: "Ex.: EAABsbCS..."
                    }
                ]
            }
        }
    }
};
